/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PaginatedVenueListList,
  PatchedVenue,
  Venue,
} from '../models/index';
import {
    PaginatedVenueListListFromJSON,
    PaginatedVenueListListToJSON,
    PatchedVenueFromJSON,
    PatchedVenueToJSON,
    VenueFromJSON,
    VenueToJSON,
} from '../models/index';

export interface VenuesCreateRequest {
    venue: Omit<Venue, 'id'|'team_name'|'stages'|'stages_count'|'total_capacity'|'created_at'|'updated_at'>;
}

export interface VenuesDestroyRequest {
    id: string;
}

export interface VenuesListRequest {
    ordering?: string;
    page?: number;
    search?: string;
}

export interface VenuesPartialUpdateRequest {
    id: string;
    patchedVenue?: Omit<PatchedVenue, 'id'|'team_name'|'stages'|'stages_count'|'total_capacity'|'created_at'|'updated_at'>;
}

export interface VenuesRetrieveRequest {
    id: string;
}

export interface VenuesStatisticsRequest {
    id: string;
}

export interface VenuesUpdateRequest {
    id: string;
    venue: Omit<Venue, 'id'|'team_name'|'stages'|'stages_count'|'total_capacity'|'created_at'|'updated_at'>;
}

/**
 * 
 */
export class VenuesApi extends runtime.BaseAPI {

    /**
     * Get venues grouped by type.
     */
    async venuesByTypeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/by_type/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * Get venues grouped by type.
     */
    async venuesByType(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesByTypeRaw(initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesCreateRaw(requestParameters: VenuesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters['venue'] == null) {
            throw new runtime.RequiredError(
                'venue',
                'Required parameter "venue" was null or undefined when calling venuesCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VenueToJSON(requestParameters['venue']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesCreate(requestParameters: VenuesCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesDestroyRaw(requestParameters: VenuesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling venuesDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesDestroy(requestParameters: VenuesDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.venuesDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesListRaw(requestParameters: VenuesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedVenueListList>> {
        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedVenueListListFromJSON(jsonValue));
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesList(requestParameters: VenuesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedVenueListList> {
        const response = await this.venuesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesPartialUpdateRaw(requestParameters: VenuesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling venuesPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedVenueToJSON(requestParameters['patchedVenue']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesPartialUpdate(requestParameters: VenuesPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesRetrieveRaw(requestParameters: VenuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling venuesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesRetrieve(requestParameters: VenuesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get statistics for a specific venue.
     */
    async venuesStatisticsRaw(requestParameters: VenuesStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling venuesStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/{id}/statistics/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * Get statistics for a specific venue.
     */
    async venuesStatistics(requestParameters: VenuesStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesUpdateRaw(requestParameters: VenuesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Venue>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling venuesUpdate().'
            );
        }

        if (requestParameters['venue'] == null) {
            throw new runtime.RequiredError(
                'venue',
                'Required parameter "venue" was null or undefined when calling venuesUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/venues/venues/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VenueToJSON(requestParameters['venue']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VenueFromJSON(jsonValue));
    }

    /**
     * ViewSet for Venue CRUD operations. Automatically filters venues by user\'s teams.
     */
    async venuesUpdate(requestParameters: VenuesUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Venue> {
        const response = await this.venuesUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
